import {
  AgeBasedDiscountQuestion,
  FileUpload,
  GeographyBasedDiscountQuestion,
  InputDate,
  InputDateRange,
  InputDateTime,
  InputTime,
} from '@/components'
import { Checkbox, Form, Input, Radio } from 'antd'
import { useRef, createRef } from 'react'
import moment from 'moment'

export const Questions = ({ trip, type = 'all', booking }) => {
  const fileInputRefs = useRef({});
  const tripDefaultDate = trip?.startDate
    ? moment(trip.startDate.toString(), 'YYYYMMDD')
    : undefined;
  const renderInput = (ques) => {
    if (!fileInputRefs.current[ques.id]) {
      fileInputRefs.current[ques.id] = createRef();
    }
    switch (ques.type) {
      case 'MultiLine':
        return <Input.TextArea />
      case 'OneLine':
        return <Input />
      case 'Url':
        return <Input />
      case 'Time':
        return <InputTime />
      case 'Date':
        return <InputDate defaultPickerValue={tripDefaultDate} />
      case 'DateTime':
        return <InputDateTime defaultPickerValue={tripDefaultDate} />
      case 'DateRange':
        return <InputDateRange defaultPickerValue={tripDefaultDate} />
      case 'UploadFile':
        return <FileUpload fileInputRef={fileInputRefs.current[ques.id]} maxCount={5} />;
      case 'GeographyBasedDiscount':
        return <GeographyBasedDiscountQuestion />
      case 'AgeBasedDiscount':
        return <AgeBasedDiscountQuestion />
      case 'OneChoice':
        return (
          <Radio.Group>
            {ques.options?.map((opt) => (
              <Radio value={opt.optionText} key={opt.id}>
                {opt.optionText}
              </Radio>
            ))}
          </Radio.Group>
        )
      case 'MultiChoice':
        return (
          <Checkbox.Group>
            {ques.options?.map((opt) => (
              <Checkbox value={opt.optionText} key={opt.id}>
                {opt.optionText}
              </Checkbox>
            ))}
          </Checkbox.Group>
        )
    }
  }
  const showQuestion = (ques) => {
    let show = false;
    
    // console.log('Checking question:', ques?.questionText, 'showQuestion:', ques?.showQuestion, 'showAtRSVP:', ques?.showAtRSVP, 'showAtBooking:', ques?.showAtBooking);
    
    // Don't show questions that are disabled
    if (!ques?.showQuestion) {
      return false;
    }
    
    // Show at Survey: only show in Survey popup when Survey is enabled
    if (ques?.showAtRSVP && type === 'survey' && trip?.isSurveyEnabled) {
      show = true;
    }
    
    // Show at Registration: show in registration popup and checkout
    if (ques?.showAtBooking && ['booking', 'all'].includes(type)) {
      show = true;
    }
    
    // For backward compatibility: if no specific setting, show in booking
    if (!ques?.showAtRSVP && !ques?.showAtBooking && ['booking', 'all'].includes(type)) {
      show = true;
    }

    // Check needed data exists for booking-specific questions
    if (booking?.rooms && ques?.selectedBookingOptions) {
      const reservedRoomsId = booking.rooms.map(room => room.variant.id);
      const selectedBookingOptionsQuest = ques.selectedBookingOptions.map((bookingOption) => bookingOption.variant.id);

      let searchId = reservedRoomsId.some(id => selectedBookingOptionsQuest.includes(id));

      if (!ques.selectedBookingOptions.length) {
        searchId = true;
      }

      if (show && searchId) {
        return true
      } else {
        return false
      }
    }

    console.log('Final show result for question:', ques?.questionText, '=', show);
    return show
  }

  const numberOfQuestion = trip?.questions?.map((ques) => showQuestion(ques)) || [];
  // console.log('Number of questions to show:', numberOfQuestion.filter(q => q).length);

  return (
    <>
      {numberOfQuestion.some(item => item === true) ? (
        (trip?.questions || []).map((ques) => {
          return showQuestion(ques) ? (
            <Form.Item
              key={['questions', `${ques.id}`]}
              name={['questions', `${ques.id}`]}
              label={ques.questionText}
              rules={[
                {
                  required: ques.isRequired,
                  message: `${ques.questionText} is required.`,
                },
              ]}
              extra={ques?.infoText || ''}
              {...(ques.type === 'UploadFile' && {
                  valuePropName: 'value',
                  getValueFromEvent: (e) => {
                      if (Array.isArray(e)) { return e; }
                      return e && e.fileList;
                  },
              })}
            >
              {renderInput(ques)}
            </Form.Item>
          ) : (
            ''
          )
        }) || ''
      ) : (
        <div className='no-questions-available-message'>No questions available</div>
      )}
    </>
  )
}
